import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Home from './Components/Home/Home';
import Products from './Components/Home/Products';
import AboutUs from './Components/Home/AboutUs';
import ContactUs from './Components/Home/ContactUs';
import TermsCondition from './Components/Home/TermsConditions';
import Careers from './Components/Home/Careers';
// import SignupDoor from './Components/Home/SignupDoor';
import ProtocolTest from './Components/Protocol/ProtocolTest';

import PaymentSuccess from './Components/Payment/PaymentSuccess';
import PaymentCancel from './Components/Payment/PaymentCancel';
import CheckoutSuccess from './Components/Payment/CheckoutSuccess';
import CheckoutCancel from './Components/Payment/CheckoutCancel';
import BookingSuccess from './Components/Payment/BookingSuccess';

import PatientCheckout from './Components/Checkout/PatientCheckout';

import Login from './Components/Auth/Login';
import ForgotPassword from './Components/Auth/ForgotPassword';
import ResetPassword from './Components/Auth/ResetPassword';
import ClinicSignUp from './Components/Auth/ClinicSignUp';
// import PatientSignUp from './Components/Auth/PatientSignUp';
import AddressConfirmation from './Components/Auth/AddressConfirmation';
import ConfirmBookingCompletion from './Components/ConfirmBookingCompletion';

import Dashboard from './Components/Dashboard/Dashboard';
import PatientForm from './Components/Pages/PatientForm';

import SMSConsent from './Components/Home/Consent';

import './global.css';

const router = createBrowserRouter([
    { path: '/', element: <Home /> },
    { path: '/products', element: <Products /> },
    { path: '/about-us', element: <AboutUs /> },
    { path: '/contact-us', element: <ContactUs /> },
    { path: '/terms-and-conditions', element: <TermsCondition /> },
    { path: '/careers', element: <Careers /> },
    // { path: '/signup', element: <SignupDoor /> },

    { path: '/payment-success', element: <PaymentSuccess /> },
    { path: '/payment-cancel', element: <PaymentCancel /> },
    { path: '/checkout-success', element: <CheckoutSuccess /> },
    { path: '/checkout-cancel', element: <CheckoutCancel /> },
    { path: '/booking-success', element: <BookingSuccess /> },
    { path: '/patient-checkout', element: <PatientCheckout /> },

    // { path: '/login', element: <Login /> },
    // { path: '/forgot-password', element: <ForgotPassword /> },
    // { path: '/reset-password/:token', element: <ResetPassword /> },

    // { path: '/patient-signup', element: <PatientSignUp /> },
    // { path: '/signup', element: <ClinicSignUp /> },
    // { path: '/confirm-address/:token', element: <AddressConfirmation /> },

    // { path: '/dashboard', element: <Dashboard /> },
    // { path: '/confirm-booking-completion/:token', element: <ConfirmBookingCompletion /> },
    // { path : "/protocol-test", element: <ProtocolTest /> },
    // { path: '/patient', element: <PatientForm /> },

    // { path: '/sms-consent', element: <SMSConsent /> },

]);

const root = createRoot(document.getElementById('root'));
root.render(<RouterProvider router={router} />);